// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Project {
        border: 1px solid #ccc;
        width: 180px;
        height: 230px;
        margin: 0 20px 20px 0;
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
        background-color: #f9f9f9;
        border-radius: 8px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    }
    .Projects.clickHandler{
        border-color: red;

}
    .Project:hover {
        transform: translateY(-5px);
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
        border-color: red;
    }
    
    .Project_icon_container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
    }
    
    .Project_icon {
        height: 60px;
    }
    
    .Project_label {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 90px;
        font-family: "Roboto", sans-serif;
        font-size: 16px;
        padding: 10px;
        text-align: center;
    }
    
    .Project_name {
        font-weight: 700;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333;
    }
    
    .Project_teamSize {
        font-size: 14px;
        color: #666;
    }
    
`, "",{"version":3,"sources":["webpack://./src/screens/Projects/Project/Project.css"],"names":[],"mappings":"AAAA;QACQ,sBAAsB;QACtB,YAAY;QACZ,aAAa;QACb,qBAAqB;QACrB,aAAa;QACb,cAAc;QACd,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,yBAAyB;QACzB,yBAAyB;QACzB,kBAAkB;QAClB,0CAA0C;IAC9C;IACA;QACI,iBAAiB;;AAEzB;IACI;QACI,2BAA2B;QAC3B,2CAA2C;QAC3C,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,WAAW;QACX,YAAY;QACZ,iCAAiC;QACjC,eAAe;QACf,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;IACf","sourcesContent":[".Project {\n        border: 1px solid #ccc;\n        width: 180px;\n        height: 230px;\n        margin: 0 20px 20px 0;\n        display: flex;\n        flex-shrink: 0;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        background-color: #f9f9f9;\n        border-radius: 8px;\n        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    }\n    .Projects.clickHandler{\n        border-color: red;\n\n}\n    .Project:hover {\n        transform: translateY(-5px);\n        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n        border-color: red;\n    }\n    \n    .Project_icon_container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        flex-grow: 1;\n    }\n    \n    .Project_icon {\n        height: 60px;\n    }\n    \n    .Project_label {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        width: 100%;\n        height: 90px;\n        font-family: \"Roboto\", sans-serif;\n        font-size: 16px;\n        padding: 10px;\n        text-align: center;\n    }\n    \n    .Project_name {\n        font-weight: 700;\n        height: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #333;\n    }\n    \n    .Project_teamSize {\n        font-size: 14px;\n        color: #666;\n    }\n    \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
